import { render, staticRenderFns } from "./QNewsList.vue?vue&type=template&id=256f83c9&"
import script from "./QNewsList.vue?vue&type=script&lang=js&"
export * from "./QNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports